/* eslint-disable max-len */
/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_PRO_STORE } from '@moderntribe/events-pro/data/prefix';

export const ADD_EXCEPTION_FIELD = `${ PREFIX_EVENTS_PRO_STORE }/ADD_EXCEPTION_FIELD`;
export const ADD_EXCEPTION = `${ PREFIX_EVENTS_PRO_STORE }/ADD_EXCEPTION`;
export const REMOVE_EXCEPTION_FIELD = `${ PREFIX_EVENTS_PRO_STORE }/REMOVE_EXCEPTION_FIELD`;
export const REMOVE_EXCEPTION = `${ PREFIX_EVENTS_PRO_STORE }/REMOVE_EXCEPTION`;
export const EDIT_EXCEPTION = `${ PREFIX_EVENTS_PRO_STORE }/EDIT_EXCEPTION`;
export const SYNC_EXCEPTIONS_FROM_DB = `${ PREFIX_EVENTS_PRO_STORE }/SYNC_EXCEPTIONS_FROM_DB`;
